import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import UpdateIcon from "@mui/icons-material/Update";
import { useHistory } from "react-router-dom";
import ReporteSucursal from "./PDF/TotalCarteraPorSucursalPDF";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { LoaderScreen } from "../../components/LoaderScreen";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation } from "react-router-dom";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import FiltroTotalCartera from "./FiltroTotalCartera";
import { useBox } from "../DashboardCobranza/helper/useBox";
import { GetKey } from "../ReporteCobranza/Actions/GetContainer";
import {
  TablaTotalCarteraDetalle,
  TotalCarteraMensualScreen,
} from "./TablaTotalCarteraDetalle";
import { TotalCarteraScreen } from "./TablaPrueba";
import { AgruparByProp } from "../../../Helpers/Agrupaciones/AgruparByProp";
import { TipoCartera } from "../ReporteCobranza/Helper/TipoCartera";
//estilos para el boton de PDF
const styles = {
  pdfDownloadLink: {
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100px",
    height: "25px",
    borderRadius: "5px",
    marginLeft: "10px",
    marginRight: "10px",
    backgroundColor: "#940404",
    cursor: "pointer",
    boxShadow: "3px 3px 3px #333",
    color: "rgba(255, 255, 255, 0.8)",
  },
};

export const TotalCateraPorSucursal = () => {
  const meses = [
    "ENERO",
    "FEBRERO",
    "MARZO",
    "ABRIL",
    "MAYO",
    "JUNIO",
    "JULIO",
    "AGOSTO",
    "SEPTIEMBRE",
    "OCTUBRE",
    "NOVIEMBRE",
    "DICIEMBRE",
  ];

  const fechaActual = new Date();
  const ejercicioActual = fechaActual.getFullYear();
  const mesActual = fechaActual.getMonth() + 1;

  const initialStateboxfiltros = () => {
    return {
      ejercicio: ejercicioActual,
      periodo: mesActual,
      tipo: "R",
      tipoCartera: "A",
      pv: {
        adr: [],
        sucursal: [],
        vendedor: [],
      },
    };
  };

  const [data, setData] = useState([]);
  const [dataDetalle, setDataDetalle] = useState({
    data: [],
    lineas: [],
    estado: [],
  });
  const history = useHistory();
  const [boxstate, setBoxState] = useBox(initialStateboxfiltros);
  const [permisos, setPermisos] = useState(null);
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const [titulo, setTitulo] = useState("TOTAL CARTERA POR SUCURSAL");

  const [mostrarResumen, setMostrarResumen] = useState(true);
  const [mostrarDetalle, setMostrarDetalle] = useState(false);
  const [mostrarDetalleMensual, setMostrarDetalleMensual] = useState(false);

  const [stateFiltro, setStateFiltro] = useState({
    ejercicio: boxstate.ejercicio,
    periodo: boxstate.periodo,
    adr: boxstate.pv.adr,
    linea: boxstate.pv.linea,
    sucursal: boxstate.pv.sucursal,
  });
  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`PermisoCobranza/GetSucursales`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setPermisos(result);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CONVENIO PAGO", JSON.stringify(error), "error");
      });
  }, []);
  useEffect(() => {
    setStateFiltro({
      ejercicio: boxstate.ejercicio,
      periodo: boxstate.periodo,
      adr: boxstate.pv.adr,
      sucursal: boxstate.pv.sucursal,
    });
  }, [boxstate]);
  useEffect(() => {
    if (permisos) {
      Actualizar();
    }
  }, [permisos]);
  // const location = useLocation();
  // const permisos = location.state;
  const Actualizar = () => {
    setLoader({ ...loader, mostrar: true });
    var sucursales = GetKey(stateFiltro.sucursal, ["idsucursal"]);
    var adr = GetKey(stateFiltro.adr, ["idadr"]);
    if (sucursales === undefined || sucursales === null || sucursales === "") {
      sucursales = GetKey(permisos, ["idsucursal"]);
    }
    if (adr === undefined || adr === null || adr === "") {
      adr = "0";
    }

    // console.log(permisos)
    request
      .get(`TotalCarteraPorSucursal/Listado?adr=${adr}&sucursal=${sucursales}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setData(result);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("TOTAL CARTERA", JSON.stringify(error), "error");
      });
  };

  const onExecute = () => {
    setLoader({ ...loader, mostrar: true });

    var sucursales = GetKey(stateFiltro.sucursal, ["idsucursal"]);
    var adr = GetKey(stateFiltro.adr, ["idadr"]);
    var lineas = GetKey(boxstate.pv.linea, ["idlinea"]);

    if (adr === undefined || adr === null || adr === "") {
      adr = "0";
    }
    if (sucursales === undefined || sucursales === null || sucursales === "") {
      if (adr === "0" || adr === "1,2") {
        sucursales = GetKey(permisos, ["idsucursal"]);
      } else {
        sucursales = "0";
      }
    }

    if (lineas === undefined || lineas === null || lineas === "") {
      lineas = "0";
    }

    const tituloP =
      boxstate.tipo === "D" && boxstate.tipoCartera === "C"
        ? `TOTAL CARTERA CIERRE ${meses[boxstate.periodo - 1]} - ${boxstate.ejercicio}`
        : boxstate.tipo === "D"
          ? `TOTAL CARTERA ACTUAL`
          : "TOTAL CARTERA POR SUCURSAL";

    setTitulo(tituloP);
    if (boxstate.tipo === "R") {
      return request
        .get(
          `TotalCarteraPorSucursal/Listado?adr=${adr}&sucursal=${sucursales}`,
        )
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          setData(result);
          setMostrarResumen(true);
          setMostrarDetalle(false);
          setMostrarDetalleMensual(false);
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("TOTAL CARTERA", JSON.stringify(error), "error");
        });
    } else if (boxstate.tipo === "D" && boxstate.tipoCartera === "A") {
      return request
        .get(
          `TotalCarteraPorSucursal/ListadoDetalle?adr=${adr}&sucursal=${sucursales}&ejercicio=${boxstate.ejercicio}&periodo=${boxstate.periodo}&linea=${lineas}`,
        )
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          // setDataDetalle(result);
          setMostrarResumen(false);
          setMostrarDetalle(true);
          setMostrarDetalleMensual(false);
          setDataDetalle({
            ...dataDetalle,
            data: result,
            lineas: AgruparByProp(result, "linea"),
            estado: AgruparByProp(result, "estatus"),
          });
          // console.log(result)
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("TOTAL CARTERA", JSON.stringify(error), "error");
        });
    } else if (boxstate.tipo === "D" && boxstate.tipoCartera === "C") {
      return request
        .get(
          `TotalCarteraPorSucursal/ListadoDetalleMensual?adr=${adr}&sucursal=${sucursales}&ejercicio=${boxstate.ejercicio}&periodo=${boxstate.periodo}&linea=${lineas}`,
        )
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          // setDataDetalle(result);
          setMostrarResumen(false);
          setMostrarDetalle(false);
          setMostrarDetalleMensual(true);

          setDataDetalle({
            ...dataDetalle,
            data: result,
            lineas: AgruparByProp(result, "linea"),
            estado: AgruparByProp(result, "estatus"),
          });
          // console.log(result)
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("TOTAL CARTERA", JSON.stringify(error), "error");
        });
    } else {
      return request
        .get(
          `TotalCarteraPorSucursal/ListadoDetalle?adr=${adr}&sucursal=${sucursales}&ejercicio=${boxstate.ejercicio}&periodo=${boxstate.periodo}&linea=${lineas}`,
        )
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          // setDataDetalle(result);
          setMostrarResumen(false);
          setMostrarDetalle(true);
          setMostrarDetalleMensual(false);

          setDataDetalle({
            ...dataDetalle,
            data: result,
            lineas: AgruparByProp(result, "linea"),
            estado: AgruparByProp(result, "estatus"),
          });
          // console.log(result)
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("TOTAL CARTERA", JSON.stringify(error), "error");
        });
    }
  };

  const onGeneraExcel = () => {
    setLoader({ ...loader, mostrar: true });
    var sucursales = GetKey(stateFiltro.sucursal, ["idsucursal"]);
    var adr = GetKey(stateFiltro.adr, ["idadr"]);
    var lineas = GetKey(boxstate.pv.linea, ["idlinea"]);

    if (adr === undefined || adr === null || adr === "") {
      adr = "0";
    }
    if (sucursales === undefined || sucursales === null || sucursales === "") {
      if (adr === "0" || adr === "1,2") {
        sucursales = GetKey(permisos, ["idsucursal"]);
      } else {
        sucursales = "0";
      }
    }

    if (lineas === undefined || lineas === null || lineas === "") {
      lineas = "0";
    }

    if (boxstate.tipo === "D" && boxstate.tipoCartera === "A") {
      setLoader({ ...loader, mostrar: true });
      request
        .get(
          `TotalCarteraPorSucursal/GenerarExcelDetalle?adr=${adr}&sucursal=${sucursales}&ejercicio=${boxstate.ejercicio}&periodo=${boxstate.periodo}&linea=${lineas}`,
        )
        .then(({ documento, filename }) => {
          const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
          const downloadLink = document.createElement("a");
          const fileName = `${filename}.xlsx`;
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
          setLoader({ ...loader, mostrar: false });
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
        });
    } else if (boxstate.tipo === "D" && boxstate.tipoCartera === "C") {
      setLoader({ ...loader, mostrar: true });

      request
        .get(
          `TotalCarteraPorSucursal/GenerarExcelDetalleMensual?adr=${adr}&sucursal=${sucursales}&ejercicio=${boxstate.ejercicio}&periodo=${boxstate.periodo}&linea=${lineas}`,
        )
        .then(({ documento, filename }) => {
          const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
          const downloadLink = document.createElement("a");
          const fileName = `${filename}.xlsx`;
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
          setLoader({ ...loader, mostrar: false });
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
        });
    } else {
      // return;
      request
        .get(
          `TotalCarteraPorSucursal/GenerarExcel?adr=${adr}&sucursal=${sucursales}`,
        )
        .then(({ documento, filename }) => {
          const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
          const downloadLink = document.createElement("a");
          const fileName = `${filename}.xlsx`;
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
          setLoader({ ...loader, mostrar: false });
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
        });
    }
  };

  //Link para descargar PDF
  const PDFDownloadButton = () => {
    setLoader({ ...loader, mostrar: true });
    var sucursales = GetKey(stateFiltro.sucursal, ["idsucursal"]);
    var adr = GetKey(stateFiltro.adr, ["idadr"]);
    if (adr === undefined || adr === null || adr === "") {
      adr = "0";
    }
    if (sucursales === undefined || sucursales === null || sucursales === "") {
      if (adr === "0" || adr === "1,2") {
        sucursales = GetKey(permisos, ["idsucursal"]);
      } else {
        sucursales = "0";
      }
    }
    request
      .get(
        `TotalCarteraPorSucursal/ReporteSucursalPDF?adr=${adr}&sucursal=${sucursales}`,
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = `data:application/pdf;base64, ${result.documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${result.nombredocumento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("Clientes", JSON.stringify(error), "error");
      });
  };

  const onSucursalSelect = (idsucursal, sucursal) => {
    history.push("/Creditoycobranza/TotalCarteraPorLinea", {
      idsucursal,
      sucursal,
    });
  };

  const capitalizeWords = (str) => {
    return str
      ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
      : "";
  };
  // console.log(location)
  const handleGoBack = () => {
    history.push("/Creditoycobranza/DashboardCobranza");
  };

  return (
    <PlantillaScreen
      titulo={titulo}
      className_main={1}
      className={"reporte-cartera-clientes-totales-main"}
    >
      <div className="reporte-cartera-clientes-totales">
        <LoaderScreen loader={loader} />
        <header id="header">
          {mostrarResumen === true ? (
            <div className="title-tabla">
              <i className="icon-right-circle tcblue"></i>
              RESUMEN DE CARTERA POR SUCURSAL
            </div>
          ) : (
            <div className="title-tabla">
              <i className="icon-right-circle tcblue"></i>
            </div>
          )}

          <div className="buttons">
            <button className="regresar" onClick={handleGoBack}>
              <ArrowBackIcon /> Regresar
            </button>
            <div className="filtro-cartera-sucursal">
              <FiltroTotalCartera
                onExecute={onExecute}
                boxState={boxstate}
                onBoxChange={setBoxState}
                sucursales={permisos}
              />
            </div>
            <button onClick={() => Actualizar()} className="actualizar">
              <UpdateIcon /> Actualizar
            </button>
            <button className="excel" onClick={onGeneraExcel}>
              <i className=" icon-file-excel" /> Excel
            </button>
            <button
              className="PDF"
              onClick={() => PDFDownloadButton()}
              style={{ backgroundColor: "#940404" }}
            >
              PDF
            </button>
          </div>
        </header>
        {mostrarResumen === true ? (
          <div className="reporte-cartera-clientes-totales-container scroll">
            <table
              className="tabla-resumen-sucursal"
              cellPadding={0}
              cellSpacing={0}
            >
              <thead>
                <tr>
                  <th>#</th>
                  <th>
                    <div>Sucursal</div>
                  </th>
                  <th>
                    <div>Total Cartera</div>
                  </th>
                  <th>
                    <div>Saldo a Favor</div>
                  </th>
                  <th>
                    <div>Total</div>
                  </th>
                  <th>
                    <div>Jurídico</div>
                  </th>

                  <th>%</th>
                  <th>
                    <div>Cartera Activa</div>
                  </th>
                  <th>%</th>
                  <th>
                    <div>Por Vencer</div>
                  </th>
                  <th>%</th>
                  <th>
                    <div>Vencida</div>
                  </th>
                  <th>%</th>
                  <th>
                    <div>De 1 a 15</div>
                  </th>
                  <th>%</th>
                  <th>
                    <div>Más de 15</div>
                  </th>
                  <th>%</th>
                  <th>
                    <div>Más de 30</div>
                  </th>
                  <th>%</th>
                  <th>
                    <div>Más de 60</div>
                  </th>
                  <th>%</th>
                  <th>
                    <div>Más de 90</div>
                  </th>
                  <th>%</th>
                </tr>
              </thead>
              <tbody>
                {data.map((x) => (
                  <tr
                    onClick={() => onSucursalSelect(x.idsucursal, x.sucursal)}
                  >
                    <td className="sticky-row-0">{x.idsucursal}</td>
                    <td className="sticky-row-50">
                      {capitalizeWords(x.sucursal)}
                    </td>
                    {/* <td>{FormatMoney(x.totalcartera + x.juridico)}</td> */}
                    <td>{FormatMoney(x.totalcartera)}</td>
                    <td>{FormatMoney(x.saldoafavor)}</td>
                    <td>{FormatMoney(x.total)}</td>
                    {/* <td>{FormatMoney(x.total + x.juridico)}</td> */}
                    <td>{FormatMoney(x.juridico)}</td>
                    <td>
                      {FormatMoney(
                        (x.juridico / (x.totalcartera)) * 100)}
                    </td>
                    <td>{FormatMoney(x.activo)}</td>
                    <td>
                      {FormatMoney(
                        (x.activo / (x.totalcartera)) * 100,
                      )}
                    </td>
                    <td>{FormatMoney(x.porvencer)}</td>
                    <td>
                      {FormatMoney(
                        (x.porvencer / (x.totalcartera)) * 100,
                      )}
                    </td>
                    <td>{FormatMoney(x.vencido)}</td>
                    <td>
                      {FormatMoney(
                        (x.vencido / (x.totalcartera)) * 100,
                      )}
                    </td>
                    <td>{FormatMoney(x.de1a15)}</td>
                    <td>{FormatMoney((x.de1a15 / x.vencido) * 100)}</td>
                    <td>{FormatMoney(x.mas15)}</td>
                    <td>{FormatMoney((x.mas15 / x.vencido) * 100)}</td>
                    <td>{FormatMoney(x.mas30)}</td>
                    <td>{FormatMoney((x.mas30 / x.vencido) * 100)}</td>
                    <td>{FormatMoney(x.mas60)}</td>
                    <td>{FormatMoney((x.mas60 / x.vencido) * 100)}</td>
                    <td>{FormatMoney(x.mas90)}</td>
                    <td>{FormatMoney((x.mas90 / x.vencido) * 100)}</td>
                    {/* <td>{FormatMoney((x.vencido / x.totalcartera) * 100)} %</td>
                <td>{FormatMoney((x.porvencer / x.totalcartera) * 100)} %</td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : mostrarDetalle === true ? (
          <TotalCarteraScreen state={dataDetalle} />
        ) : mostrarDetalleMensual === true ? (
          <TotalCarteraMensualScreen state={dataDetalle} />
        ) : (
          <div></div>
        )}
      </div>
    </PlantillaScreen>
  );
};
